import { ThumbnailComponent } from "./chunk-XBWYJ2D7.js";
import { PanelComponent } from "./chunk-CES4KXAE.js";
import { TransitionComponent } from "./chunk-3HAR27K6.js";
import { Link_default } from "./chunk-EFRJ3CR6.js";
import { Spinner_default } from "./chunk-KRDKEFRG.js";
import { Icon_default } from "./chunk-BTGG6N6L.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/FileInput/FileInput.File.tsx
import clsx from "clsx";
import React, { forwardRef } from "react";
var FileInputFile = forwardRef((_a, ref) => {
  var _b = _a,
    {
      id,
      image = /* @__PURE__ */React.createElement(Icon_default, {
        icon: "image"
      }),
      name,
      size,
      type,
      onDelete,
      deleteLabel,
      isLoading,
      className
    } = _b,
    rest = __objRest(_b, ["id", "image", "name", "size", "type", "onDelete", "deleteLabel", "isLoading", "className"]);
  return /* @__PURE__ */React.createElement(TransitionComponent, {
    show: true,
    appear: true,
    variant: "appear-from-top"
  }, /* @__PURE__ */React.createElement(PanelComponent, __spreadValues({
    ref,
    as: "article",
    className: clsx("pd-file-input-file", className)
  }, rest), /* @__PURE__ */React.createElement("div", {
    className: "pd-flex pd-justify-between"
  }, /* @__PURE__ */React.createElement("div", null, /* @__PURE__ */React.createElement("strong", {
    className: "pd-mb-2 pd-block"
  }, name), /* @__PURE__ */React.createElement("span", {
    className: "pd-block"
  }, size), /* @__PURE__ */React.createElement("span", {
    className: "pd-block"
  }, type)), isLoading ? /* @__PURE__ */React.createElement(Spinner_default, {
    size: "xl"
  }) : /* @__PURE__ */React.createElement(ThumbnailComponent, {
    size: "xs",
    className: "pd-file-input-file__image"
  }, image)), /* @__PURE__ */React.createElement("footer", {
    className: "pd-mt-4 pd-flex pd-justify-end pd-border-t pd-pt-4"
  }, /* @__PURE__ */React.createElement(Link_default, {
    as: "button",
    variant: "secondary",
    onClick: onDelete,
    iconBefore: "trashcan"
  }, deleteLabel))));
});
var FileInput_File_default = FileInputFile;
export { FileInput_File_default };